import { Contract } from '../../../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../../../models/Entities/Contracts/ContractAddendum';
import { ContractStage } from '../../../../../models/Entities/Contracts/ContractStage';
import { ContractStageItemViewModel } from '../../../../../models/Entities/Contracts/ContractStageItemViewModel';
import { ErrorType } from '../../../../../models/HttpError';
import { AppState } from '../../../../../redux/reducers';

// store
import * as ContractStageItemStore from '../../../../../redux/middleware/ContractStageItem.Middleware';

interface IProps {
    ContractStage: ContractStage;
    ProtocolId: number | undefined;
}

interface ConnectedProps {
    StageItems: ContractStageItemViewModel[];
    error: ErrorType | undefined;
}

interface DispatchProps {
    GetAllContractStageItems: typeof ContractStageItemStore.actionCreators.GetAllContractStageItems;
    AddContractStageItem: typeof ContractStageItemStore.actionCreators.AddContractStageItem;
    DeleteContractStageItem: typeof ContractStageItemStore.actionCreators.DeleteContractStageItem;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    let currentStage: ContractStage | undefined;

    (state.Contract?.list || []).forEach((contract: Contract) => {
        (contract.addendums || []).forEach((addendum: ContractAddendum) => {
            const stage = (addendum.stages || []).find((item: ContractStage) => item.id === ownProps.ContractStage.id);
            if (stage) {
                currentStage = stage;
            }
        });
    });

    return {
        StageItems: (currentStage?.contractStageItems || []).slice().sort((a, b) =>
            (a.emrProtocolVisitName || '').localeCompare(b.emrProtocolVisitName || '')
        ),
        error: state.Contract?.error
    };
};

export const mapDispatchToProps = {
    ...ContractStageItemStore.actionCreators
};
